 // ESTILOS
import styles from '../../estilos/inicioRegistro.module.css';
// PAQUETES
import React, {useState} from "react";
import axios from "axios";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import Swal from 'sweetalert2';
// COMPONENTES
import FooterInicioRegistro from '../../partials/footerInicioRegistro';
import SincronizarGoogle from './sincronizarGoogle';
import ZonaCargando from '../alertas/zonaCargando';
 

function EliminarDatos() {
  
    const navigate = useNavigate();
    const location = useLocation();
    const { returnTo, returnState } = location.state || {}; // páginas a las que se debe volver en dado caso, como reserva o otroas.
    const { usuario, cargandoUsuario, setUsuario } = useOutletContext() || {}; // variables de context

    const[input, setInput]        = useState ({  usuarioInicio: "", contraseña: "" });
    const [cargando, setCargando] = useState(false);
    
    function handleChange(event){
        const {name, value} = event.target;
        // guardar el valor previo.
        setInput(prevInput => {
            return {
                ...prevInput,
                [name]: value
            }
        });
    }

    function handleClick(event){
        // evita el parpadeo predefinido
        event.preventDefault();
        setCargando(true);

        // crear objeto para pasar a servidor
        const nUsuario = {
            username: input.usuarioInicio,
            password: input.contraseña
        }

        // pasar datos a servidor o bd.
        axios.post("/eliminar-usuario", nUsuario, {withCredentials: "true"})
        .then(function (response) {
            setCargando(false);
            // error al eliminar usuario
            if (response.data.eliminado !== true) {
                Swal.fire({ icon: 'error', title: "Error", text: response.data.mensaje, customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar', cancelButton: 'mi-boton-cancelar' }, });
            }
            // eliminación exitosa
            else {
                return navigate("/");
            }
        })
        .catch(function(err){
            setCargando(false);
            Swal.fire({
                icon: 'error',
                title: "Error",
                text: "Error iniciando sesión. Vuelve a intentar",
                customClass: {
                    popup: 'mi-modal',
                    confirmButton: 'mi-boton-confirmar',
                    cancelButton: 'mi-boton-cancelar'
                },
            });
            console.log('error iniciar-sesion: ', err);
        });
    }

    

 
    

    return(
    <div className={styles.containerUsuario}>
        { (cargando) ? <ZonaCargando />
        : <main className={styles['form-signin']}>
            <form>
            {/* Imagen y título */}
            <div className='d-flex justify-content-center'>
            <a href='/'>
                <img className="my-5" src="/imagenes/marca/zervicyblancohorizontal.png" alt="" height="80" />
                </a>
            </div>
            <h3 className="h3 mb-3 fw-normal text-light text-center">Eliminar datos</h3>

            {/* usuario */}
            <div className="form-floating">
                <input onChange={handleChange} value={input.usuarioInicio} name="usuarioInicio" type="text" className="form-control"  placeholder="miusuario123" />
                <label htmlFor="floatingInput">Usuario</label>
            </div>


            {/* Contraseña  */}
            <div className="form-floating">
                <input onChange={handleChange} value={input.contraseña} name="contraseña" type="password" className="form-control" id="floatingPassword" placeholder="Password" />
                <label htmlFor="floatingPassword">contraseña</label>
            </div>

            {/* Botón enviar */}
            <button onClick={handleClick} className="btn btn-primary w-100 py-2" type="submit">
                <i className="bi bi-box-arrow-in-right me-2" />
                Borrar datos
            </button>

            
          
            


            {/* footer */}
            <FooterInicioRegistro desdeDonde={"borrar"} />                
            </form>
        </main>
        }
    </div>
    )
}



export default EliminarDatos;